import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ApplicationFeatures } from 'app/app-features.enum';

import { CurrentUserState } from './current-user.reducer';

// Selector functions
const getCurrentUserFeatureState = createFeatureSelector<CurrentUserState>('current_user');

// Get tenantId from current user
export const getTenantId = createSelector(
    getCurrentUserFeatureState,
    (state: CurrentUserState) => state.currentUserState.currentUser.tenantId,
);

// Get all features from current user
export const getCurrentUserFeatures = createSelector(
    getCurrentUserFeatureState,
    (state: CurrentUserState) => state.currentUserState.currentUser.features,
);

// Create a factory function that takes the feature as an argument
export const createHasCurrentUserFeatureSelector = (feature: string) =>
    createSelector(getCurrentUserFeatureState, (state: CurrentUserState) => {
        const features = state.currentUserState.currentUser?.features;
        return features?.some((f) => f.name === feature && f.state === true) ?? false;
    });

export const hasUserManageReportsFeature = createHasCurrentUserFeatureSelector(
    ApplicationFeatures.manageReports,
);

export const getCurrentUser = createSelector(
    getCurrentUserFeatureState,
    (state: CurrentUserState) => state.currentUserState.currentUser,
);

export const getCurrentUserError = createSelector(
    getCurrentUserFeatureState,
    (state: CurrentUserState) => state.currentUserState.error,
);

export const getCurrentUserLoading = createSelector(
    getCurrentUserFeatureState,
    (state: CurrentUserState) => state.currentUserState.loading,
);

export const getCurrentUserDone = createSelector(
    getCurrentUserFeatureState,
    (state: CurrentUserState) => state.currentUserState.done,
);

export const isCurrentUserInternalUser = createSelector(
    getCurrentUserFeatureState,
    (state: CurrentUserState) => state.currentUserState.currentUser.isInternalUser,
);
